"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paragraph = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/text/text");
const text_styles_1 = require("@/components/common/text/text.styles");
const utils_1 = require("@/utils");
const paragraphMaxWidthTokens = {
    small: { 'max-width': '560px' },
    medium: { 'max-width': '560px' },
    large: { 'max-width': '800px' },
};
/**
 * 본문 문단. 글자 크기·색·줄 수는 mm-text를 p로 렌더해 단계를 고르고,
 * 이 컴포넌트는 본문 크기 이름(small·medium·large)과 읽기 폭만 소유한다.
 */
let Paragraph = class Paragraph extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.size = 'medium';
        this.color = 'inherit';
        this.maxLines = '';
        this.centered = false;
    }
    render() {
        return (0, lit_1.html) `
      <mm-text
        as="p"
        size=${text_styles_1.paragraphSizeToTextSize[this.size]}
        color=${this.color}
        max-lines=${this.maxLines}
        ?centered=${this.centered}
      >
        <slot></slot>
      </mm-text>
    `;
    }
};
Paragraph.styles = (0, lit_1.css) `
    :host {
      display: block;
      font-weight: var(--font-weight-normal);
    }

    ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('size', paragraphMaxWidthTokens))}
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Paragraph.prototype, "size", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Paragraph.prototype, "color", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'max-lines' })
], Paragraph.prototype, "maxLines", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], Paragraph.prototype, "centered", void 0);
Paragraph = __decorate([
    (0, decorators_js_1.customElement)('mm-paragraph')
], Paragraph);
exports.Paragraph = Paragraph;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFyYWdyYXBoLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicGFyYWdyYXBoLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFzRDtBQUN0RCxxREFBMkQ7QUFFM0QseUNBQXNDO0FBQ3RDLHNFQUs2QztBQUM3QyxtQ0FBbUU7QUFFbkUsTUFBTSx1QkFBdUIsR0FBbUM7SUFDOUQsS0FBSyxFQUFFLEVBQUUsV0FBVyxFQUFFLE9BQU8sRUFBRTtJQUMvQixNQUFNLEVBQUUsRUFBRSxXQUFXLEVBQUUsT0FBTyxFQUFFO0lBQ2hDLEtBQUssRUFBRSxFQUFFLFdBQVcsRUFBRSxPQUFPLEVBQUU7Q0FDaEMsQ0FBQTtBQUVEOzs7R0FHRztBQUVJLElBQU0sU0FBUyxHQUFmLE1BQU0sU0FBVSxTQUFRLGdCQUFVO0lBQWxDOztRQVNzQyxTQUFJLEdBQWtCLFFBQVEsQ0FBQTtRQUM3QyxVQUFLLEdBQWMsU0FBUyxDQUFBO1FBQ0osYUFBUSxHQUFpQixFQUFFLENBQUE7UUFDbEQsYUFBUSxHQUFHLEtBQUssQ0FBQTtJQWUvQyxDQUFDO0lBYkMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7OztlQUdBLHFDQUF1QixDQUFDLElBQUksQ0FBQyxJQUFJLENBQUM7Z0JBQ2pDLElBQUksQ0FBQyxLQUFLO29CQUNOLElBQUksQ0FBQyxRQUFRO29CQUNiLElBQUksQ0FBQyxRQUFROzs7O0tBSTVCLENBQUE7SUFDSCxDQUFDOztBQXpCTSxnQkFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7TUFNZixJQUFBLGVBQVMsRUFBQyxJQUFBLDJCQUFtQixFQUFDLE1BQU0sRUFBRSx1QkFBdUIsQ0FBQyxDQUFDO0dBQ2xFLENBQUE7QUFDMEM7SUFBMUMsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7dUNBQStCO0FBQzdDO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzt3Q0FBNkI7QUFDSjtJQUFuRCxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLFNBQVMsRUFBRSxXQUFXLEVBQUUsQ0FBQzsyQ0FBNEI7QUFDbEQ7SUFBNUIsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRSxDQUFDOzJDQUFpQjtBQVpsQyxTQUFTO0lBRHJCLElBQUEsNkJBQWEsRUFBQyxjQUFjLENBQUM7R0FDakIsU0FBUyxDQTJCckI7QUEzQlksOEJBQVMifQ==